import { apiRequest } from './apiClient';
import { ConversationResponse, SendAgentMessagePayload, SendMessagePayload } from '../chatTypes';
import { getCustomer, getAgentUniqId, getAgentId, getUserId } from '../chatUtils';
import chatProperties from '../config/chatProperties';
import { getParsedParentUserId, isSubAdmin } from '../../../../../services/auth-service';

let reqCounter = 0;

const getDefaultAgentPayload = () => {
    reqCounter++;
    return { ns: 'ozonetel.cloudagent', utid: reqCounter }
}

// Chat API endpoints
const ENDPOINTS = {
    SEARCH: '/getLoggedInAgentsGroupWise',
    SEND_MESSAGE: '/senderMessage',
    GET_HISTORY: '/getHistory',
    GET_ALL: '/getActiveAgentList'
};

const chatService = {
    conversations: {
        getAll: (signal: AbortSignal) => {
            if (chatProperties.type === 'Agent') {
                return apiRequest.post<ConversationResponse>('', {
                    ...getDefaultAgentPayload(),
                    type: 'tbGetSubUserList',
                    customer: getCustomer(),
                }, { signal });
            } else {
                return apiRequest.post<ConversationResponse>(ENDPOINTS.GET_ALL, {
                    subUserId: getUserId(),
                    UserId: isSubAdmin() ? getParsedParentUserId() : getUserId()
                }, { signal });
            }
        },
        getById: (id: number, signal: AbortSignal, name?: string) => {
            if (chatProperties.type === 'Agent') {
                return apiRequest.post<ConversationResponse>('', {
                    ...getDefaultAgentPayload(),
                    "type": "tbGetSubUserChatHist",
                    customer: name,
                    agentUniqId: getAgentUniqId(),
                    subUserId: id,
                    agentId: getAgentId(),
                    subUserName: name
                }, { signal });
            } else {
                const userId = getUserId();
                return apiRequest.post<ConversationResponse>(ENDPOINTS.GET_HISTORY, {
                    agentUniqId: id,
                    subUserId: userId
                }, { signal });
            }
        },
    },

    messages: {
        send: (payload: SendMessagePayload | SendAgentMessagePayload) => {
            if (chatProperties.type === 'Agent') {

                return apiRequest.post<{ Status: string, Message: string }>('', {
                    ...getDefaultAgentPayload(),
                    type: 'tbSendMsgToSubUser',
                    agentUniqId: getAgentUniqId(),
                    agentId: getAgentId(),
                    ...payload
                });
            } else {
                return apiRequest.post<{ Status: string, Message: string }>(ENDPOINTS.SEND_MESSAGE, payload);
            }
        },
    },

    search: {
        query: (signal?: AbortSignal) => {
            if (chatProperties.type === 'Agent') {
                reqCounter++;
                return apiRequest.post('', {
                    ...getDefaultAgentPayload(),
                    type: 'tbGetSubUserList',
                    customer: getCustomer(),
                    agentId: getAgentId(),
                    agentUniqId: getAgentUniqId(),
                }, { signal });
            } else {
                return apiRequest.get(`${ENDPOINTS.SEARCH}`, { signal });
            }
        },
    },
};

export default chatService; 